import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CardSmallComponent } from "./card-small.component";
import { DssTooltipModule } from '@dss/components/tooltip';
import { DssTypographyModule } from '@dss/components/typography';
import { DssIconModule } from '@dss/components/icon';
import { CustomPipesModule } from "../../pipes/pipes.module";


@NgModule({
    declarations: [CardSmallComponent],
    imports: [
        CommonModule,
        DssTypographyModule,
        DssTooltipModule,
        DssIconModule,
        CustomPipesModule,
    ],
    exports: [CardSmallComponent],
})
export class CardSmallModule {

}
